/**
 * Trunnion AI - Parallel Join Node
 * Merges parallel execution paths.
 */

import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import { GitMerge } from 'lucide-react';
import type { ParallelNodeData } from '@/types';
import { useWorkflowDesignerStore } from '@/stores/workflowDesignerStore';

export const ParallelJoinNode = memo(function ParallelJoinNode({
  id,
  data,
  selected,
}: NodeProps & { data: ParallelNodeData }) {
  const setSelectedNodeId = useWorkflowDesignerStore((s) => s.setSelectedNodeId);

  return (
    <div
      className={`min-w-45 rounded-xl border-2 bg-trunnion-slate-800 shadow-lg transition-all ${
        selected
          ? 'border-cyan-500 shadow-[0_0_15px_rgba(6,182,212,0.3)]'
          : 'border-cyan-500/40 hover:border-cyan-500/60'
      }`}
      onClick={() => setSelectedNodeId(id)}
    >
      <div className="flex items-center justify-center gap-2 bg-cyan-500/10 px-3 py-3">
        <GitMerge className="h-5 w-5 text-cyan-400" />
        <span className="text-sm font-semibold text-white">
          {data.label || 'Join'}
        </span>
      </div>
      <div className="px-3 py-2 text-center">
        <span className="text-xs text-trunnion-slate-400">
          Strategy: {data.strategy ?? 'all'}
        </span>
      </div>

      <Handle
        type="target"
        position={Position.Top}
        id="join-in-1"
        className="!bg-trunnion-slate-800 !border-cyan-500"
        style={{ left: '30%' }}
      />
      <Handle
        type="target"
        position={Position.Top}
        id="join-in-2"
        className="!bg-trunnion-slate-800 !border-cyan-500"
        style={{ left: '70%' }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        className="!bg-trunnion-slate-800 !border-cyan-500"
      />
    </div>
  );
});
